import { render } from "./CoinsStackedIcon.vue?vue&type=template&id=dd8fabde"
import script from "./CoinsStackedIcon.vue?vue&type=script&lang=js"
export * from "./CoinsStackedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__